import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { PUBLIC_API_KEYS } from '@store/slices/resources';
import { ThunkGetPublicApiKey } from '@store/slices/publicApiKey/thunks';

const initialState = {
  publicApiKey: {},
  isLoading: false,
};

const publicApiKeys = createSlice({
  name: PUBLIC_API_KEYS,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(ThunkGetPublicApiKey.fulfilled, (state, { payload }) => {
        state.publicApiKey = payload;
        state.isLoading = false;
      })
      .addMatcher(isAnyOf(ThunkGetPublicApiKey.pending), state => {
        state.isLoading = true;
      });
  },
});

export default publicApiKeys.reducer;

export const PublicApiKeySelector = state =>
  state[PUBLIC_API_KEYS].publicApiKey;

export const PublicApiKeyLoadingSelector = state =>
  state[PUBLIC_API_KEYS].isLoading;
